import * as Yup from 'yup';
import { isValidPhoneNumber } from '../../../../../utils/validators';
import termsAgreementTexts from '../TermsAgreement/texts.json';

const validationSchema = Yup.object().shape({
  password: Yup.string()
    .min(6, 'Password must be at least 6 characters')
    .required('Password is required'),
  firstName: Yup.string()
    .required('First Name is required'),
  lastName: Yup.string()
    .required('Last Name is required'),
  email: Yup.string()
    .email('Enter a valid Email Address')
    .required('Email is required'),
  phoneNumber: Yup.string()
    .required('Phone Number is required')
    .test('isPhoneNumber', 'Enter a valid Phone Number', isValidPhoneNumber),
});

/*
  On a checkout whose first page also takes the terms, the account can only be created once they are agreed: the
  tick box is a field of this form, so it is validated and submitted with the rest.
*/
const termsAgreementValidationSchema = validationSchema.shape({
  // Required as well: a field the form started without is undefined, which oneOf alone lets through.
  hasAgreedToTerms: Yup.boolean().required(termsAgreementTexts.required).oneOf([true], termsAgreementTexts.required),
});

const getValidationSchema = ({ requiresTermsAgreement }) => (
  requiresTermsAgreement ? termsAgreementValidationSchema : validationSchema
);

const initialValues = {
  firstName: '',
  lastName: '',
  email: '',
  phoneNumber: '',
  password: '',
};

const getInitialValues = (updatedInitialValues) => {
  const newInitialValues = { ...initialValues };
  Object.keys(newInitialValues).forEach((key) => {
    if (updatedInitialValues[key]) {
      newInitialValues[key] = updatedInitialValues[key];
    }
  });
  return newInitialValues;
};

export {
  validationSchema,
  getValidationSchema,
  getInitialValues,
};
